import NegotitationIcon from "../../assets/negotiation.png";
import BusinessCostIcon from "../../assets/cost.png";
import ComplianceIcon from "../../assets/compliance.png";
import OpportunityIcon from "../../assets/opportunity.svg";
import ReminderIcon from "../../assets/reminder.jpg";
import ReportsIcon from "../../assets/report-notification.svg";
import ReviewIcon from "../../assets/review.svg";
import moment from "moment";

const MapModulesToIcons = (module: string | undefined) => {
  switch (module) {
    case "upcoming_negotiations":
      return NegotitationIcon;
    case "business_cost":
      return BusinessCostIcon;
    case "compliance_monitoring":
      return ComplianceIcon;
    case "nia_opportunity":
      return OpportunityIcon;
    default:
      return BusinessCostIcon;
  }
};

export const MapNotificationsToIcons = (
  module: string | undefined,
  isReminder: boolean
) => {
  if (isReminder) {
    return ReminderIcon;
  }
  switch (module) {
    case "volume allocation":
      return NegotitationIcon;
    case "business cost":
      return BusinessCostIcon;
    case "compliance monitoring":
      return ComplianceIcon;
    case "volume compliance":
      return ComplianceIcon;
    case "nia_opportunity":
      return OpportunityIcon;
    case "reports":
      return ReportsIcon;
    case "review":
      return ReviewIcon;
    default:
      return BusinessCostIcon;
  }
};

export default MapModulesToIcons;

export const revertTransform = (
  value: string | string[]
): string | string[] => {
  const monthMapping: { [key: string]: string } = {
    Jan: "January",
    Feb: "February",
    Mar: "March",
    Apr: "April",
    May: "May",
    Jun: "June",
    Jul: "July",
    Aug: "August",
    Sep: "September",
    Oct: "October",
    Nov: "November",
    Dec: "December",
  };

  const revertDate = (shortDate: string): string => {
    const [shortMonth, shortYear] = shortDate.split(" ");
    const fullMonth = monthMapping[shortMonth];
    const fullYear = `20${shortYear}`;
    return `${fullMonth} ${fullYear}`;
  };

  // Handle single value or array
  if (typeof value === "string") {
    return revertDate(value);
  } else {
    return value.map(revertDate);
  }
};

export const revertTransformWire = (
  value: string | string[]
): string | string[] => {
  const monthMapping: { [key: string]: string } = {
    Jan: "January",
    Feb: "February",
    Mar: "March",
    Apr: "April",
    May: "May",
    Jun: "June",
    Jul: "July",
    Aug: "August",
    Sep: "September",
    Oct: "October",
    Nov: "November",
    Dec: "December",
  };

  const revertDate = (shortDate: string): string => {
    const [shortMonth, Year] = shortDate.split(" ");
    const fullMonth = monthMapping[shortMonth];
    const fullYear = `${Year}`;
    return `${fullMonth} ${fullYear}`;
  };

  // Handle single value or array
  if (typeof value === "string") {
    return revertDate(value);
  } else {
    return value.map(revertDate);
  }
};

export const transformYearDate = (dates: { year_date: string }[]) => {
  return dates.map((item) => {
    const [month, year] = item.year_date.split(" ");
    const shortMonth = month.slice(0, 3);
    const shortYear = year.slice(2);
    return { ...item, year_date: `${shortMonth} ${shortYear}` };
  });
};

export const containsValue = (
  arr: any[],
  key: string,
  value: string | number
) => {
  return arr.some((obj) => obj[key] === value);
};

export function deepCompare(obj1: any, obj2: any) {
  // Check if both are the same reference
  if (obj1 === obj2) return true;

  // Check if either is null or not an object
  if (
    obj1 == null ||
    obj2 == null ||
    typeof obj1 !== "object" ||
    typeof obj2 !== "object"
  ) {
    return false;
  }

  // Get keys of both objects
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  // Check if the number of keys is different
  if (keys1.length !== keys2.length) return false;

  // Check each key and value recursively
  for (let key of keys1) {
    if (!keys2.includes(key) || !deepCompare(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}

export const convertDateToMonthYear = (dateString: string, interval = 0) => {
  // Parse the ISO date string into a Date object
  const date = new Date(dateString);

  // Adjust the date by the specified interval (in months)
  date.setUTCMonth(date.getUTCMonth() + interval);

  // Array of month names
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Extract the month and year using UTC methods
  const month = monthNames[date.getUTCMonth()]; // Get the month in UTC
  const year = date.getUTCFullYear(); // Get the year in UTC

  // Return the formatted string
  return `${month} ${year}`;
};

// Returns the current month/year (adjusted by `interval` months) based on the
// user's local date. Building the Date from local year/month components makes
// it timezone-proof (no UTC parsing that can shift across a day boundary).
export const getCurrentMonthYear = (interval = 0) => {
  const now = new Date();

  // Construct a local date on the 1st of the month, then shift by interval.
  const date = new Date(now.getFullYear(), now.getMonth() + interval, 1);

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return `${monthNames[date.getMonth()]} ${date.getFullYear()}`;
};


export function formatISOToLong(iso: string): string {
  const MONTHS = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const [y, m, d] = iso.split("-");
  if (!y || !m || !d) return iso;
  const monthIndex = Number(m) - 1;
  if (monthIndex < 0 || monthIndex > 11) return iso;
  const day = parseInt(d, 10);
  if (Number.isNaN(day)) return iso;
  return `${day} ${MONTHS[monthIndex]} ${y}`;
}

export const convertDateToFullDate = (dateString: string, interval = 0) => {
  // Parse the ISO date string into a Date object
  const date = new Date(dateString);

  // Adjust the date by the specified interval (in months)
  date.setUTCMonth(date.getUTCMonth() + interval);

  // Array of month names
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Extract the month and year using UTC methods
  const day = date.getUTCDate();
  const month = monthNames[date.getUTCMonth()]; // Get the month in UTC
  const year = date.getUTCFullYear(); // Get the year in UTC

  // Return the formatted string
  return `${day} ${month} ${year}`;
};

export function formatMonthShortYear(dateStr?: string): string {
  if (!dateStr) return "";
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const [year, month] = dateStr.split("-");
  const monthIndex = parseInt(month, 10) - 1;
  if (!year || monthIndex < 0 || monthIndex > 11) return "";
  return `${months[monthIndex]} ${year}`;
}

// Returns the Monday of the current week (week considered to start on Monday).
export const getMondayOfCurrentWeek = (): Date => {
  const now = new Date();
  const day = now.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
  const offsetFromMonday = day === 0 ? 6 : day - 1;

  const monday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  monday.setDate(monday.getDate() - offsetFromMonday);
  return monday;
};

// Returns the Monday of the current week formatted as "D Month YYYY", e.g. "14 September 2026".
export const getMondayOfCurrentWeekLabel = (): string => {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const monday = getMondayOfCurrentWeek();
  const day = monday.getDate().toString().padStart(2, "0");
  const month = monthNames[monday.getMonth()];
  const year = monday.getFullYear();

  return `${day} ${month} ${year}`;
};

export function formatDateToLong(dateStr: string): string {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const [year, month, day] = dateStr.split("-");

  // Remove any leading zeros for the day, and ensure two-digit day
  const formattedDay = day.padStart(2, "0");
  const monthIndex = parseInt(month, 10) - 1;

  return `${formattedDay} ${months[monthIndex]} ${year}`;
}

export function getYTDTransactionRange() {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth(); // 0-indexed (0 = January, 1 = February, ..., 4 = April, 5 = May)

  // Define the start month (January)
  const startMonth = 0; // January (0-indexed)

  // Create an array to hold the formatted month strings
  let startMonthName = new Date(currentYear, startMonth).toLocaleString(
    "default",
    { month: "short" }
  );
  let endMonthName = new Date(currentYear, currentMonth - 1).toLocaleString(
    "default",
    { month: "short" }
  );

  // Format the output as "Jan'25 - Apr'25"
  return `${startMonthName}'${currentYear
    .toString()
    .slice(-2)} - ${endMonthName}'${currentYear.toString().slice(-2)}`;
}

export function getNetworkingDaysInMonth(year: number, month: number) {
  let networkingDays = 0;
  const lastDay = new Date(year, month, 0).getDate(); // Get the last day of the month

  // Loop through each day of the month
  for (let d = 1; d <= lastDay; d++) {
    const currentDate = new Date(year, month - 1, d); // month is 0-indexed
    const dayOfWeek = currentDate.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday

    // Check if the day is a weekday (Monday to Friday)
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      networkingDays++;
    }
  }
  return networkingDays;
}
export function getNetworkingDaysUpToToday(dayTobe: number): number {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth(); // 0-indexed
  const day = dayTobe;
  let networkingDays = 0;
  for (let d = 1; d <= day; d++) {
    const currentDate = new Date(year, month, d);
    const dayOfWeek = currentDate.getDay(); // 0 = Sunday, 6 = Saturday
    if (dayOfWeek >= 1 && dayOfWeek <= 5) {
      networkingDays++;
    }
  }
  return networkingDays;
}

export function calculateNetworkingDaysUntilEndOfMonth(dateString: string) {
  let dateMomentObject = moment(dateString, "DD-MMM-YYYY"); // 1st argument - string, 2nd argument - format
  let dateObject = dateMomentObject.toDate();
  const today = dateObject; // Get today's date
  const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0); // Get the last day of the current month
  let workingDays = 0;

  for (let date = today; date <= endOfMonth; date.setDate(date.getDate() + 1)) {
    const dayOfWeek = date.getDay();
    // Check if it's a weekday (Monday to Friday)
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      workingDays++;
    }
  }
  return workingDays;
}
